module.exports = __webpack_public_path__ + "static/media/ring.fafc75ee.svg";